(() => {
  // OpticalH/GC search pilot build: 2026-07-22 cache-bust.
  const INTENT_ALIASES = {
    rimless: ['al aire', 'sin montura', 'sin monturas', 'sin aro', 'sin aros', 'rimless'],
    'product_type:sol': ['gafas de sol', 'gafa de sol', 'gafas sol', 'gafa sol', 'gafas solares', 'gafa solar', 'sunglasses', 'sunglass'],
    'product_type:graduadas': ['gafas graduadas', 'gafa graduada', 'gafas graduados', 'gafas de vista', 'gafa de vista', 'gafas ópticas', 'gafas opticas', 'gafa óptica', 'gafa optica', 'monturas', 'montura', 'eyeglasses', 'eyeglass', 'prescription glasses', 'optical glasses', 'optical frames', 'frames'],
    'product_type:inteligentes': ['gafas inteligentes', 'gafa inteligente', 'smart glasses'],
    'stock:in_stock': ['en stock', 'con stock', 'stock', 'disponible ahora', 'disponibles ahora', 'disponible ya', 'disponibles ya', 'entrega inmediata', 'in stock', 'available now'],
    'stock:backorder': ['por encargo', 'bajo pedido', 'back order', 'back-order', 'backorder'],
    'sale:on_sale': ['en oferta', 'de oferta', 'rebajado', 'rebajada', 'rebajados', 'rebajadas', 'con descuento', 'on sale'],
    'colors:negro': ['negro', 'negra', 'negros', 'negras', 'black'],
    'colors:marron': ['marrón', 'marron', 'marrones', 'brown'],
    'colors:azul': ['azul', 'azules', 'blue'],
    'colors:rojo': ['rojo', 'roja', 'rojos', 'rojas', 'red'],
    'colors:verde': ['verde', 'verdes', 'green'],
    'colors:rosa': ['rosa', 'rosas', 'pink'],
    'colors:blanco': ['blanco', 'blanca', 'blancos', 'blancas', 'white'],
    'colors:gris': ['gris', 'grises', 'grey', 'gray'],
    'colors:dorado': ['dorado', 'dorada', 'dorados', 'doradas', 'oro', 'gold', 'golden'],
    'colors:plateado': ['plateado', 'plateada', 'plateados', 'plateadas', 'silver'],
    'colors:transparente': ['transparente', 'transparentes', 'trasparente', 'trasparentes', 'clear'],
    'colors:carey': ['carey', 'tortoiseshell'],
    'colors:havana': ['havana', 'habana'],
    'colors:multicolor': ['multicolor', 'multicolour'],
    'colors:violeta': ['violeta', 'violetas', 'purple'],
    'colors:amarillo': ['amarillo', 'amarilla', 'amarillos', 'amarillas', 'yellow'],
    'colors:burdeos': ['burdeos', 'burgundy'],
    'colors:beige': ['beige'],
    'colors:bronce': ['bronce', 'bronze'],
    'shapes:ojo-de-gato': ['ojo de gato', 'ojo-de-gato', 'cat eye', 'cat-eye', 'cateye'],
    'shapes:retro-wayfarer': ['retro wayfarer', 'retro-wayfarer'],
    'shapes:doble-puente': ['doble puente', 'doble-puente', 'double bridge', 'double-bridge'],
    'shapes:redonda': ['redondo', 'redonda', 'redondos', 'redondas', 'circular', 'circulares', 'round'],
    'shapes:cuadrada': ['cuadrado', 'cuadrada', 'cuadrados', 'cuadradas', 'square'],
    'shapes:rectangular': ['rectangular', 'rectangulares'],
    'shapes:ovalada': ['ovalado', 'ovalada', 'ovalados', 'ovaladas', 'oval'],
    'shapes:aviador': ['aviador', 'aviadores', 'aviator'],
    'shapes:deportiva': ['deportivo', 'deportiva', 'deportivos', 'deportivas', 'sport', 'sports', 'sporty'],
    'shapes:mariposa': ['mariposa', 'mariposas', 'butterfly', 'butterflies'],
    'shapes:irregular': ['irregular', 'irregulares'],
    'shapes:pillow': ['pillow'],
    'shapes:piloto': ['piloto', 'pilotos'],
    'shapes:pantalla': ['pantalla', 'pantallas', 'shield'],
    'shapes:phantos': ['phantos', 'pantos'],
    'shapes:hexagonal': ['hexagonal', 'hexagonales'],
    'shapes:octogonal': ['octogonal', 'octogonales'],
    'shapes:geometrica': ['geométrico', 'geométrica', 'geométricos', 'geométricas', 'geometrico', 'geometrica', 'geometricos', 'geometricas'],
    'shapes:wayfarer': ['wayfarer'],
    'shapes:clubmaster': ['clubmaster'],
    'genders:mujer': ['mujer', 'mujeres', 'femenino', 'femenina', 'femeninos', 'femeninas', 'women', 'woman', 'female'],
    'genders:hombre': ['hombre', 'hombres', 'masculino', 'masculina', 'masculinos', 'masculinas', 'men', 'man', 'male'],
    'genders:niño': ['niño', 'niña', 'niños', 'niñas', 'infantil', 'infantiles', 'kid', 'kids', 'child', 'children'],
    'genders:unisex': ['unisex'],
    'materials:acetato': ['acetato', 'acetate'],
    'materials:titanio': ['titanio', 'titanium'],
    'materials:metal': ['metal', 'metálico', 'metálica', 'metálicos', 'metálicas', 'metalico', 'metalica', 'metalicos', 'metalicas'],
    'materials:plástico': ['plástico', 'plástica', 'plásticos', 'plásticas', 'plastico', 'plastica', 'plasticos', 'plasticas', 'plastic'],
    'materials:inyectado': ['inyectado', 'inyectada', 'inyectados', 'inyectadas'],
    'materials:aluminio': ['aluminio', 'aluminium', 'aluminum'],
    'materials:acero': ['acero', 'steel'],
    'materials:carbono': ['carbono', 'carbon'],
    'materials:madera': ['madera', 'wood'],
    'sizes:pequena': ['pequeño', 'pequeña', 'pequeños', 'pequeñas', 'small'],
    'sizes:mediana': ['mediano', 'mediana', 'medianos', 'medianas', 'medium'],
    'sizes:grande': ['grande', 'grandes', 'large'],
    'lens_filters:polarizado': ['polarizado', 'polarizada', 'polarizados', 'polarizadas', 'polarised', 'polarized'],
    'lens_filters:degradado': ['degradado', 'degradada', 'degradados', 'degradadas', 'gradient'],
    'lens_filters:espejo': ['espejo', 'espejado', 'espejada', 'espejados', 'espejadas', 'mirrored'],
    'lens_filters:prizm': ['prizm'],
    'lens_filters:fotocromatico': ['fotocromático', 'fotocromática', 'fotocromáticos', 'fotocromáticas', 'fotocromatico', 'fotocromatica', 'fotocromaticos', 'fotocromaticas', 'photochromic'],
    'lens_filters:luz-azul': ['filtro de luz azul', 'luz azul', 'blue light'],
    'lens_filters:antirreflejante': ['antirreflejante', 'anti reflective', 'anti-reflective']
  };

  function escapePattern(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function phrasePattern(values) {
    const source = values
      .filter(Boolean)
      .sort((first, second) => second.length - first.length)
      .map(value => escapePattern(value).replace(/[\s-]+/g, '[\\s-]+'))
      .join('|');
    return new RegExp(`(^|[^\\p{L}\\p{N}])(?:${source})(?=$|[^\\p{L}\\p{N}])`, 'giu');
  }

  function normalizeQuery(value) {
    return String(value || '').replace(/\s+/g, ' ').replace(/^[\s,.;:/&-]+|[\s,.;:/&-]+$/g, '').trim();
  }

  function shouldHideComparePrice(product) {
    if (!product || typeof product !== 'object') return false;
    return product.hide_compare_price === true
      || String(product.vendor || '').trim().toLocaleLowerCase('en') === 'chanel';
  }

  function intentPattern(intent) {
    if (INTENT_ALIASES[intent]) return phrasePattern(INTENT_ALIASES[intent]);
    if (String(intent).startsWith('vendor:')) {
      const value = String(intent).slice(7);
      const aliases = [value];
      if (value.toLocaleLowerCase('en') === 'ray-ban') aliases.push('ray ban', 'rayban');
      if (value.toLocaleLowerCase('en') === 'yves saint laurent') aliases.push('ysl');
      return phrasePattern(aliases);
    }
    const [field, ...parts] = String(intent).split(':');
    if (!field || !parts.length) return null;
    return phrasePattern([parts.join(':').replaceAll('-', ' ')]);
  }

  function removeIntentFromQuery(query, intent) {
    let result = String(query || '');
    if (String(intent).startsWith('price:')) {
      const number = '(?:\\d+(?:[.,]\\d{1,2})?)';
      const between = `(?:entre|between)\\s*€?\\s*${number}\\s*(?:€|euros?)?\\s*(?:y|and|a|to|-)\\s*€?\\s*${number}\\s*(?:€|euros?)?`;
      const maximum = `(?:(?:por\\s+)?menos\\s+de|hasta|m[aá]ximo|under|below|up\\s+to)\\s*€?\\s*${number}\\s*(?:€|euros?)?`;
      const minimum = `(?:m[aá]s\\s+de|desde|over|above|from)\\s*€?\\s*${number}\\s*(?:€|euros?)?`;
      const source = String(intent).startsWith('price:max:') ? maximum : String(intent).startsWith('price:min:') ? minimum : between;
      result = result.replace(new RegExp(`(^|[^\\p{L}\\p{N}])(?:${source})(?=$|[^\\p{L}\\p{N}])`, 'giu'), '$1');
    } else {
      const pattern = intentPattern(intent);
      if (pattern) result = result.replace(pattern, '$1');
    }
    return normalizeQuery(result);
  }

  function removeIntentsFromQuery(query, intents) {
    return (intents || []).reduce(removeIntentFromQuery, String(query || ''));
  }

  function isInferredCheckbox(control) {
    return control?.dataset?.ohsInferred === 'true';
  }

  function isExplicitCheckbox(control) {
    return Boolean(control?.checked && !isInferredCheckbox(control));
  }

  function syncInferredCheckbox(control, active) {
    if (!control) return false;
    const wasInferred = isInferredCheckbox(control);
    if (active) {
      // Preserve a manual selection. Only controls checked by an inferred
      // query are tagged so they can later be cleared with that intent.
      if (!control.checked) {
        control.checked = true;
        control.dataset.ohsInferred = 'true';
      }
    } else if (wasInferred) {
      control.checked = false;
      delete control.dataset.ohsInferred;
    }
    return isInferredCheckbox(control);
  }

  function freshFacetItems(items, current = '') {
    const values = new Map();
    for (const item of items || []) {
      if (!item || item.value == null) continue;
      values.set(String(item.value), { value: String(item.value), count: Number(item.count) || 0 });
    }
    if (current && !values.has(current)) values.set(current, { value: current, count: 0 });
    return [...values.values()];
  }

  function searchQueryFromHref(href, base) {
    try {
      const url = new URL(href, base);
      return normalizeQuery(url.searchParams.get('q') || '');
    } catch (_) {
      return '';
    }
  }

  function isLocalizedSearchPath(pathname, rootUrl = '/') {
    try {
      const rootPath = new URL(rootUrl || '/', 'https://store.invalid').pathname.replace(/\/?$/, '/');
      const expected = `${rootPath}search`.replace(/\/{2,}/g, '/').replace(/\/$/, '');
      const candidate = new URL(String(pathname || '/'), 'https://store.invalid').pathname.replace(/\/$/, '');
      return candidate === expected;
    } catch (_) {
      return false;
    }
  }

  function localizedProductUrl(source, origin, rootUrl) {
    try {
      const url = new URL(source, origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const productIndex = parts.lastIndexOf('products');
      if (productIndex < 0 || !parts[productIndex + 1]) return source;
      const localizedRoot = new URL(rootUrl || '/', origin).pathname.replace(/\/?$/, '/');
      return `${localizedRoot}products/${encodeURIComponent(decodeURIComponent(parts[productIndex + 1]))}${url.search}${url.hash}`;
    } catch (_) {
      return source;
    }
  }

  function consentAllowsAnalytics({ globalPrivacyControl = false, analyticsProcessingAllowed, userCanBeTracked, fallback = false } = {}) {
    if (globalPrivacyControl) return false;
    if (typeof analyticsProcessingAllowed === 'boolean') return analyticsProcessingAllowed;
    if (typeof userCanBeTracked === 'boolean') return userCanBeTracked;
    return Boolean(fallback);
  }

  function sendCartAttribution(fetcher, url, context, allowed) {
    if (!allowed || typeof fetcher !== 'function' || !context?.session_id || !context?.request_id) return false;
    const body = new URLSearchParams();
    body.set('attributes[_oh_search_session]', String(context.session_id).slice(0, 120));
    body.set('attributes[_oh_search_request_id]', String(context.request_id).slice(0, 120));
    if (context.product_id != null) body.set('attributes[_oh_search_product_id]', String(context.product_id).slice(0, 40));
    try {
      Promise.resolve(fetcher(url, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: body.toString()
      })).catch(() => {});
      return true;
    } catch (_) {
      return false;
    }
  }

  function canRunOwnedSearch(canary = {}) {
    return canary?.variant === 'own';
  }

  function ownedSearchRuntime(scope, documentObject) {
    try {
      const router = documentObject?.getElementById?.('oh-search-canary-router');
      const dataset = router?.dataset;
      if (!dataset || dataset.runtimeStatus !== 'ready' || dataset.runtimeVariant !== 'own') return null;

      const state = String(dataset.runtimeState || '');
      const percent = Number(dataset.runtimePercent);
      const experiment = String(dataset.runtimeExperiment || '').slice(0, 80);
      const reason = String(dataset.runtimeReason || '');
      const currentThemeId = String(dataset.currentThemeId || '');
      const mainThemeId = String(dataset.mainThemeId || '');
      const pilotThemeId = String(dataset.pilotThemeId || '');
      if (!['staff', 'percentage'].includes(state)) return null;
      const fullRollout = state === 'percentage'
        && percent === 100
        && reason === 'full_rollout'
        && !experiment;
      if (!Number.isFinite(percent) || percent < 0 || (!fullRollout && percent > 5)) return null;
      if ((state === 'staff' && percent !== 0) || (!fullRollout && !experiment)) return null;
      if (!['forced_own', 'stored_override', 'new_bucket', 'stored_bucket', 'full_rollout'].includes(reason)) return null;
      if (!currentThemeId || !mainThemeId || !pilotThemeId || mainThemeId === pilotThemeId) return null;
      if (currentThemeId !== pilotThemeId) return null;

      const candidates = [scope?.OH_SEARCH_CANARY, scope?.window?.OH_SEARCH_CANARY]
        .filter((candidate, index, values) => candidate && values.indexOf(candidate) === index);
      for (const candidate of candidates) {
        if (typeof candidate !== 'object' || candidate.variant !== 'own') return null;
        if (candidate.state && String(candidate.state) !== state) return null;
      }
      return Object.freeze({
        experiment,
        variant: 'own',
        state,
        percent,
        reason,
        currentThemeId,
        mainThemeId,
        pilotThemeId
      });
    } catch (_) {
      return null;
    }
  }

  function healthFallbackUrl(href, mainThemeId) {
    try {
      const url = new URL(href);
      const returnHash = url.hash.slice(1);
      url.searchParams.delete('oh_search_variant');
      url.searchParams.set('preview_theme_id', String(mainThemeId));
      url.searchParams.set('_fd', '0');
      url.searchParams.set('pb', '0');
      const params = new URLSearchParams({ failed: '1' });
      if (returnHash && returnHash.length <= 2048) params.set('return_hash', returnHash);
      url.hash = `oh-search-health-v1?${params.toString()}`;
      return url.href;
    } catch (_) {
      return '';
    }
  }

  if (globalThis.__OH_SEARCH_TEST__) {
    globalThis.__OH_SEARCH_TEST_API__ = Object.freeze({
      consentAllowsAnalytics,
      canRunOwnedSearch,
      freshFacetItems,
      healthFallbackUrl,
      isLocalizedSearchPath,
      localizedProductUrl,
      normalizeQuery,
      ownedSearchRuntime,
      removeIntentFromQuery,
      removeIntentsFromQuery,
      shouldHideComparePrice,
      isExplicitCheckbox,
      isInferredCheckbox,
      sendCartAttribution,
      searchQueryFromHref,
      syncInferredCheckbox
    });
  }

  const root = globalThis.document?.getElementById('oh-search-pilot');
  if (!root || !('HTMLDialogElement' in window)) return;

  let ownedRuntimeStarted = false;

  function startOwnedRuntime() {
    if (ownedRuntimeStarted) return true;
    const runtimeScope = typeof window === 'object' && window ? window : globalThis;
    const runtimeConfig = runtimeScope.OH_SEARCH_CONFIG || globalThis.OH_SEARCH_CONFIG || {};
    const canaryConfig = ownedSearchRuntime(runtimeScope, globalThis.document);
    // If a Shopify preview redirect fails, the router deliberately falls back to
    // control. Keep this interceptor hidden so a control session can never run
    // the owned search merely because it remained on the pilot theme.
    if (!canRunOwnedSearch(canaryConfig)) return false;
    ownedRuntimeStarted = true;
    root.dataset.runtimeStatus = 'active';
  const endpoint = String(runtimeConfig.endpoint || root.dataset.endpoint || '').replace(/\/$/, '');
  const language = String(root.dataset.language || root.dataset.locale || 'es');
  const locale = language.toLocaleLowerCase('en').startsWith('en') ? 'en' : 'es';
  const country = String(root.dataset.country || 'ES').toLocaleUpperCase('en');
  const market = String(root.dataset.market || '');
  const currency = String(root.dataset.currency || root.dataset.indexCurrency || 'EUR').toLocaleUpperCase('en');
  const indexCurrency = String(root.dataset.indexCurrency || currency).toLocaleUpperCase('en');
  const localizedRootUrl = root.dataset.rootUrl || '/';
  const dialog = root.querySelector('.ohs-dialog');
  const form = root.querySelector('[data-ohs-form]');
  const input = root.querySelector('[data-ohs-query]');
  const status = root.querySelector('[data-ohs-status]');
  const results = root.querySelector('[data-ohs-results]');
  const controls = root.querySelector('[data-ohs-controls]');
  const vendor = root.querySelector('[data-ohs-vendor]');
  const vendorSearch = root.querySelector('[data-ohs-vendor-search]');
  const type = root.querySelector('[data-ohs-type]');
  const gender = root.querySelector('[data-ohs-gender]');
  const shape = root.querySelector('[data-ohs-shape]');
  const color = root.querySelector('[data-ohs-color]');
  const material = root.querySelector('[data-ohs-material]');
  const style = root.querySelector('[data-ohs-style]');
  const size = root.querySelector('[data-ohs-size]');
  const lens = root.querySelector('[data-ohs-lens]');
  const price = root.querySelector('[data-ohs-price]');
  const stock = root.querySelector('[data-ohs-stock]');
  const sale = root.querySelector('[data-ohs-sale]');
  const rimless = root.querySelector('[data-ohs-rimless]');
  const reset = root.querySelector('[data-ohs-reset]');
  const filterDone = root.querySelector('[data-ohs-filter-done]');
  const filterCount = root.querySelector('[data-ohs-filter-count]');
  const close = root.querySelector('[data-ohs-close]');
  const intents = root.querySelector('[data-ohs-intents]');
  const pagination = root.querySelector('[data-ohs-pagination]');
  const showing = root.querySelector('[data-ohs-showing]');
  const loadMore = root.querySelector('[data-ohs-load-more]');
  const errorBox = root.querySelector('[data-ohs-error]');
  const errorText = root.querySelector('[data-ohs-error-text]');
  const retry = root.querySelector('[data-ohs-retry]');

  const labels = locale === 'en'
    ? {
        initial: 'Try a brand, model, SKU, EAN or describe the glasses you need.',
        minimum: 'Enter at least 2 characters.',
        searching: 'Searching…',
        loadingMore: (shown, total) => `Loading more products. Showing ${shown} of ${total}.`,
        showing: (shown, total) => `Showing ${shown} of ${total} products`,
        none: 'No matching products',
        emptyHelp: 'Try another term, clear the filters or use classic search.',
        requestError: 'We could not update the results. Check your connection and try again.',
        requestErrorPrevious: 'We could not update the search. The previous results are still shown.',
        timeoutError: 'The search is taking longer than expected. Try again.',
        timeoutErrorPrevious: 'The search took too long. The previous results are still shown.',
        retry: 'Try again',
        loadMore: 'Load more',
        loading: 'Loading…',
        clearFilters: 'Clear filters',
        classic: 'Use classic search',
        inStock: 'In stock',
        order: 'Available to order',
        imageUnavailable: 'Image unavailable',
        currentPrice: 'Current price',
        previousPrice: 'Previous price',
        priceFilterUnavailable: `Price filtering is available in ${indexCurrency} only for this market.`,
        fromPrice: value => `From ${value}`,
        priceRange: (minimum, maximum) => `Price range: ${minimum}–${maximum}`,
        removeIntent: value => `Remove ${value}`,
        activeFilters: count => `${count} active`,
        viewResults: count => count ? `View ${count} results` : 'View results',
        all: {
          vendor: 'All brands',
          type: 'All types',
          gender: 'All genders',
          shape: 'All shapes',
          color: 'All colours',
          material: 'All materials',
          style: 'All styles',
          size: 'All sizes',
          lens: 'All lens types'
        },
        intent: {
          rimless: 'Frame: rimless',
          'product_type:sol': 'Type: sunglasses',
          'product_type:graduadas': 'Type: optical glasses',
          'product_type:inteligentes': 'Type: smart glasses',
          'stock:in_stock': 'Availability: in stock',
          'stock:backorder': 'Availability: made to order',
          'sale:on_sale': 'Promotion: on sale'
        },
        intentPrefix: { vendor: 'Brand', colors: 'Colour', shapes: 'Shape', genders: 'Gender', materials: 'Material', sizes: 'Size', lens_filters: 'Lens', price: 'Price' }
      }
    : {
        initial: 'Busca por marca, modelo, SKU, EAN o describe la gafa que buscas.',
        minimum: 'Escribe al menos 2 caracteres.',
        searching: 'Buscando…',
        loadingMore: (shown, total) => `Cargando más productos. Mostrando ${shown} de ${total}.`,
        showing: (shown, total) => `Mostrando ${shown} de ${total} productos`,
        none: 'No encontramos productos',
        emptyHelp: 'Prueba otro término, limpia los filtros o usa la búsqueda clásica.',
        requestError: 'No hemos podido actualizar los resultados. Comprueba tu conexión y reintenta.',
        requestErrorPrevious: 'No hemos podido actualizar la búsqueda. Siguen visibles los resultados anteriores.',
        timeoutError: 'La búsqueda está tardando más de lo esperado. Vuelve a intentarlo.',
        timeoutErrorPrevious: 'La búsqueda ha tardado demasiado. Siguen visibles los resultados anteriores.',
        retry: 'Reintentar',
        loadMore: 'Cargar más',
        loading: 'Cargando…',
        clearFilters: 'Limpiar filtros',
        classic: 'Usar búsqueda clásica',
        inStock: 'En stock',
        order: 'Disponible por encargo',
        imageUnavailable: 'Imagen no disponible',
        currentPrice: 'Precio actual',
        previousPrice: 'Precio anterior',
        priceFilterUnavailable: `El filtro de precio solo está disponible en ${indexCurrency} para este mercado.`,
        fromPrice: value => `Desde ${value}`,
        priceRange: (minimum, maximum) => `Rango de precios: ${minimum}–${maximum}`,
        removeIntent: value => `Quitar ${value}`,
        activeFilters: count => `${count} activos`,
        viewResults: count => count ? `Ver ${count} resultados` : 'Ver resultados',
        all: {
          vendor: 'Todas las marcas',
          type: 'Todos los tipos',
          gender: 'Todos los géneros',
          shape: 'Todas las formas',
          color: 'Todos los colores',
          material: 'Todos los materiales',
          style: 'Todos los estilos',
          size: 'Todas las tallas',
          lens: 'Todos los tipos de lente'
        },
        intent: {
          rimless: 'Montura: al aire',
          'product_type:sol': 'Tipo: gafas de sol',
          'product_type:graduadas': 'Tipo: gafas graduadas',
          'product_type:inteligentes': 'Tipo: gafas inteligentes',
          'stock:in_stock': 'Disponibilidad: en stock',
          'stock:backorder': 'Disponibilidad: por encargo',
          'sale:on_sale': 'Promoción: en oferta'
        },
        intentPrefix: { vendor: 'Marca', colors: 'Color', shapes: 'Forma', genders: 'Género', materials: 'Material', sizes: 'Talla', lens_filters: 'Lente', price: 'Precio' }
      };

  const displayNames = locale === 'en'
    ? {
        'gafas de sol': 'Sunglasses',
        'gafas graduadas': 'Optical glasses',
        'suplemento solar': 'Clip-on sunglasses',
        gafas: 'Glasses',
        'gafas inteligentes': 'Smart glasses',
        pequena: 'Small', pequeña: 'Small', mediana: 'Medium', grande: 'Large',
        mujer: 'Women', hombre: 'Men', unisex: 'Unisex', niño: 'Kids', nino: 'Kids',
        negro: 'Black', dorado: 'Gold', multicolor: 'Multicolour', gris: 'Grey', azul: 'Blue',
        rojo: 'Red', verde: 'Green', rosa: 'Pink', plata: 'Silver', transparente: 'Clear',
        marron: 'Brown', marrón: 'Brown', blanco: 'White', naranja: 'Orange', amarillo: 'Yellow',
        violeta: 'Violet', burdeos: 'Burgundy', beige: 'Beige', cobre: 'Copper', bronce: 'Bronze',
        matte: 'Matte', 'dos-colores': 'Two-tone', habana: 'Havana', havana: 'Havana',
        cuadrada: 'Square', cuadrado: 'Square', rectangular: 'Rectangular', redonda: 'Round',
        redondo: 'Round', circular: 'Round', aviador: 'Aviator', mariposa: 'Butterfly',
        'ojo-de-gato': 'Cat-eye', 'ojo de gato': 'Cat-eye', ovalada: 'Oval', ovalado: 'Oval',
        geometrica: 'Geometric', geométrica: 'Geometric', hexagonal: 'Hexagonal', octogonal: 'Octagonal',
        acetato: 'Acetate', metal: 'Metal', titanio: 'Titanium', plastico: 'Plastic', plástico: 'Plastic',
        aluminio: 'Aluminium', acero: 'Steel', carbono: 'Carbon fibre', madera: 'Wood',
        'acetato y metal': 'Acetate and metal', uniforme: 'Solid tint', degradado: 'Gradient',
        polarizado: 'Polarised', fotocromatico: 'Photochromic', fotocromático: 'Photochromic',
        espejo: 'Mirrored', espejado: 'Mirrored', antirreflejante: 'Anti-reflective',
        'espejo-azul': 'Blue mirror', 'espejo-verde': 'Green mirror', 'espejo-rosa': 'Pink mirror',
        'espejo-rojo': 'Red mirror', 'espejo-plata': 'Silver mirror', 'espejo-dorado': 'Gold mirror',
        'espejo-naranja': 'Orange mirror', 'espejo-violeta': 'Violet mirror',
        'filtro-azul': 'Blue-light filter', 'luz-azul': 'Blue-light filter'
      }
    : {
        pequena: 'Pequeña', pequeña: 'Pequeña', mediana: 'Mediana', grande: 'Grande',
        marron: 'Marrón', mujer: 'Mujer', hombre: 'Hombre', unisex: 'Unisex', niño: 'Niño',
        'ojo-de-gato': 'Ojo de gato', 'ojo de gato': 'Ojo de gato', geometrica: 'Geométrica',
        plastico: 'Plástico', fotocromatico: 'Fotocromático', 'dos-colores': 'Dos colores'
      };

  const facetConfigs = [
    { select: vendor, key: 'vendors', all: labels.all.vendor, humanize: false, items: [] },
    { select: type, key: 'product_types', all: labels.all.type, humanize: true, items: [] },
    { select: gender, key: 'genders', all: labels.all.gender, humanize: true, items: [] },
    { select: shape, key: 'shapes', all: labels.all.shape, humanize: true, items: [] },
    { select: color, key: 'colors', all: labels.all.color, humanize: true, items: [] },
    { select: material, key: 'materials', all: labels.all.material, humanize: true, items: [] },
    { select: style, key: 'styles', all: labels.all.style, humanize: true, items: [] },
    { select: size, key: 'sizes', all: labels.all.size, humanize: true, items: [] },
    { select: lens, key: 'lens_filters', all: labels.all.lens, humanize: true, items: [] }
  ];
  const facetSelects = [...facetConfigs.map(config => config.select), price];
  const moneyFormatters = new Map();

  let enabled = false;
  let healthState = 'unknown';
  let healthPromise = null;
  let healthFallbackStarted = false;
  let timer = 0;
  let controller = null;
  let requestSequence = 0;
  let lastQuery = '';
  let currentPage = 0;
  let totalFound = 0;
  let renderedCount = 0;
  let hasMore = false;
  let lastSemantic = false;
  let currentIntents = [];
  let currentRequestId = '';
  let currentResultMode = '';
  let currentResponseCurrency = indexCurrency;
  let lastTrigger = null;
  let lastFailure = null;
  let suppressSearchTriggerFocus = false;
  const boundSearchTriggers = typeof WeakSet === 'function' ? new WeakSet() : null;
  const seenProducts = new Set();

  let sessionId = '';
  try {
    sessionId = sessionStorage.getItem('ohs_session') || '';
    if (!sessionId) {
      const random = globalThis.crypto?.getRandomValues
        ? crypto.getRandomValues(new Uint32Array(2)).join('-')
        : Math.random().toString(36).slice(2);
      sessionId = `${Date.now()}-${random}`;
      sessionStorage.setItem('ohs_session', sessionId);
    }
  } catch (_) {
    sessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  controls.open = false;

  function createRequestId() {
    return globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  function formatMoney(value, currencyCode = currency) {
    const code = /^[A-Z]{3}$/.test(String(currencyCode)) ? String(currencyCode) : indexCurrency;
    if (!moneyFormatters.has(code)) {
      try {
        moneyFormatters.set(code, new Intl.NumberFormat(language, { style: 'currency', currency: code }));
      } catch (_) {
        moneyFormatters.set(code, new Intl.NumberFormat(locale === 'en' ? 'en-IE' : 'es-ES', { style: 'currency', currency: indexCurrency }));
      }
    }
    return moneyFormatters.get(code).format(Number(value) || 0);
  }

  function selectedFilters() {
    const selected = {};
    if (vendor.value) selected.vendor = vendor.value;
    if (type.value) selected.product_type = type.value;
    if (gender.value) selected.gender = gender.value;
    if (shape.value) selected.shape = shape.value;
    if (color.value) selected.color = color.value;
    if (material.value) selected.material = material.value;
    if (style.value) selected.style = style.value;
    if (size.value) selected.size = size.value;
    if (lens.value) selected.lens_filter = lens.value;
    if (price.value) selected.price = price.value;
    if (stock.checked) selected.in_stock = true;
    if (sale.checked) selected.on_sale = true;
    if (isExplicitCheckbox(rimless)) selected.rimless = true;
    return selected;
  }

  function analyticsAllowed() {
    const privacy = globalThis.Shopify?.customerPrivacy;
    let analyticsProcessingAllowed;
    let userCanBeTracked;
    try {
      if (typeof privacy?.analyticsProcessingAllowed === 'function') analyticsProcessingAllowed = Boolean(privacy.analyticsProcessingAllowed());
      if (typeof privacy?.userCanBeTracked === 'function') userCanBeTracked = Boolean(privacy.userCanBeTracked());
    } catch (_) {
      return false;
    }
    return consentAllowsAnalytics({
      globalPrivacyControl: navigator.globalPrivacyControl === true,
      analyticsProcessingAllowed,
      userCanBeTracked,
      fallback: root.dataset.analyticsWithoutConsent === 'true'
    });
  }

  function analyticsEvent(eventType, context = {}) {
    if (!analyticsAllowed()) return;
    const eventId = createRequestId();
    const detail = {
      event_id: eventId,
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      session_id: sessionId,
      locale,
      language,
      country,
      market,
      currency: context.currency ?? currentResponseCurrency,
      query: context.query ?? lastQuery,
      request_id: context.request_id ?? currentRequestId,
      page: context.page ?? currentPage,
      position: context.position ?? null,
      product_id: context.product_id == null ? null : String(context.product_id),
      result_count: context.result_count ?? totalFound,
      filters: context.filters ?? selectedFilters(),
      intents: context.intents ?? [...currentIntents],
      mode: context.mode ?? currentResultMode,
      ms: context.ms ?? null,
      reason: context.reason ?? null,
      status: context.status ?? null
    };
    if (canaryConfig.experiment) detail.experiment = String(canaryConfig.experiment).slice(0, 80);
    if (canaryConfig.variant) detail.variant = String(canaryConfig.variant).slice(0, 20);
    document.dispatchEvent(new CustomEvent('ohs:analytics', { detail }));

    const telemetryEndpoint = String(runtimeConfig.telemetryEndpoint || root.dataset.telemetryEndpoint || '');
    if (telemetryEndpoint) {
      fetch(telemetryEndpoint, {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(detail)
      }).catch(() => {});
    }

    const serverPayload = {
      event_id: eventId,
      event_type: eventType,
      occurred_at: detail.occurred_at,
      session_id: sessionId,
      query: String(detail.query || '').slice(0, 250),
      locale,
      language: String(language || '').slice(0, 20),
      country,
      currency: detail.currency,
      filters: detail.filters,
      intents: detail.intents,
      mode: String(detail.mode || '').slice(0, 40) || null,
      ms: Number.isFinite(Number(detail.ms)) ? Math.max(0, Number(detail.ms)) : null,
      reason: detail.reason == null ? null : String(detail.reason).slice(0, 80),
      status: detail.status == null ? null : Number(detail.status)
    };
    if (market) serverPayload.market = market;
    if (detail.request_id) serverPayload.request_id = String(detail.request_id).slice(0, 120);
    if (Number(detail.page) >= 1) serverPayload.page = Number(detail.page);
    if (Number(detail.position) >= 1) serverPayload.position = Number(detail.position);
    if (detail.result_count != null) serverPayload.result_count = Math.max(0, Number(detail.result_count) || 0);
    if (detail.product_id != null) serverPayload.product_id = String(detail.product_id).slice(0, 40);
    if (canaryConfig.experiment) serverPayload.experiment = String(canaryConfig.experiment).slice(0, 80);
    if (canaryConfig.variant === 'own' || canaryConfig.variant === 'control') serverPayload.variant = canaryConfig.variant;
    fetch(`${endpoint}/v1/events`, {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(serverPayload)
    }).catch(() => {});
  }

  function rememberAttribution(context) {
    if (!analyticsAllowed()) return;
    try {
      sessionStorage.setItem('ohs_attribution', JSON.stringify({ ...context, saved_at: Date.now() }));
    } catch (_) {}
  }

  function recentAttribution() {
    if (!analyticsAllowed()) return null;
    try {
      const stored = JSON.parse(sessionStorage.getItem('ohs_attribution') || 'null');
      if (!stored || Date.now() - Number(stored.saved_at) > 86_400_000) return null;
      return stored;
    } catch (_) {
      return null;
    }
  }

  function persistCartAttribution(context) {
    let cartUpdateUrl = '/cart/update.js';
    try {
      const rootPath = String(localizedRootUrl || '/').replace(/\/?$/, '/');
      cartUpdateUrl = new URL(`${rootPath}cart/update.js`, location.origin).pathname;
    } catch (_) {}
    return sendCartAttribution(fetch.bind(globalThis), cartUpdateUrl, {
      session_id: sessionId,
      request_id: context.request_id,
      product_id: context.product_id
    }, analyticsAllowed());
  }

  function classicSearchUrl(query = input.value.trim()) {
    try {
      const url = new URL(root.dataset.fallbackUrl || '/search', location.origin);
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      return url.origin === location.origin ? `${url.pathname}${url.search}${url.hash}` : url.href;
    } catch (_) {
      const suffix = query ? `?q=${encodeURIComponent(query)}` : '';
      return `${root.dataset.fallbackUrl || '/search'}${suffix}`;
    }
  }

  function updateNativeLinks(query = input.value.trim()) {
    const href = classicSearchUrl(query);
    root.querySelectorAll('[data-ohs-native]').forEach(link => { link.href = href; });
  }

  function cancelPending() {
    clearTimeout(timer);
    requestSequence += 1;
    if (controller) controller.abort();
    controller = null;
    results.setAttribute('aria-busy', 'false');
    results.classList.remove('is-refining');
    loadMore.disabled = false;
    loadMore.textContent = labels.loadMore;
    filterDone.disabled = false;
  }

  function openSearch(trigger) {
    if (!enabled) return;
    if (healthState === 'unknown') verifyHealth();
    root.hidden = false;
    if (!dialog.open) {
      lastTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement;
      controls.open = false;
      try {
        dialog.showModal();
      } catch (_) {
        location.assign(classicSearchUrl());
        return;
      }
    }
    requestAnimationFrame(() => input.focus());
  }

  function closeSearch() {
    cancelPending();
    if (!dialog.open) return;
    // Browsers restore focus to the element that opened a modal dialog before
    // dispatching `close`. Suppress trigger focus first so that restoration
    // cannot immediately reopen the search.
    suppressSearchTriggerFocus = true;
    dialog.close();
  }

  function flushRouterOpenRequest() {
    const pending = globalThis.OH_SEARCH_OPEN_PENDING;
    if (!enabled || !pending) return false;
    try { globalThis.OH_SEARCH_OPEN_PENDING = null; } catch (_) {}
    openSearch(pending.trigger);
    return true;
  }

  function queueRouterOpenRequest(eventObject) {
    const pending = eventObject?.detail || globalThis.OH_SEARCH_OPEN_PENDING;
    if (!pending) return;
    try { globalThis.OH_SEARCH_OPEN_PENDING = pending; } catch (_) {}
    flushRouterOpenRequest();
  }

  document.addEventListener('ohs:open-request', queueRouterOpenRequest);

  function searchTriggerContext(trigger) {
    if (!(trigger instanceof Element)) return null;
    const controlsSearch = trigger.matches('button[aria-controls="search-drawer"], a[aria-controls="search-drawer"], [data-open-search]');
    let searchLink = false;
    let linkedQuery = '';
    if (trigger instanceof HTMLAnchorElement) {
      try {
        const url = new URL(trigger.href, location.href);
        searchLink = url.origin === location.origin && isLocalizedSearchPath(url.pathname, localizedRootUrl);
        if (searchLink) linkedQuery = searchQueryFromHref(url.href, location.href);
      } catch (_) {
        searchLink = false;
      }
    }
    if (!controlsSearch && !searchLink) return null;
    return { linkedQuery };
  }

  function activateSearchTrigger(trigger, eventObject) {
    const context = searchTriggerContext(trigger);
    if (!context) return false;
    if (typeof eventObject.preventDefault === 'function') eventObject.preventDefault();
    if (typeof eventObject.stopPropagation === 'function') eventObject.stopPropagation();
    // The Shopify theme installs its own search-drawer handler early on
    // `document`. Intercepting on `window`, the first capture target, prevents
    // the event from reaching that drawer without silencing unrelated sibling
    // listeners that may also live on `window`.
    if (context.linkedQuery) {
      input.value = context.linkedQuery;
      updateNativeLinks(context.linkedQuery);
    }
    openSearch(trigger);
    if (context.linkedQuery.length >= 2) search({ useSemantic: true, append: false, followRedirect: true });
    return true;
  }

  function closestSearchTrigger(eventObject) {
    if (!(eventObject.target instanceof Element)) return null;
    if (eventObject.target.closest('#oh-search-pilot')) return null;
    const selector = 'button[aria-controls="search-drawer"], a[aria-controls="search-drawer"], [data-open-search], a[href]';
    const trigger = eventObject.target.closest(selector);
    if (trigger) return trigger;
    if (typeof eventObject.composedPath === 'function') {
      for (const item of eventObject.composedPath()) {
        if (item instanceof Element && !item.closest('#oh-search-pilot') && item.matches(selector)) return item;
      }
    }
    return null;
  }

  function intercept(eventObject) {
    if (!enabled) return;
    if (eventObject instanceof MouseEvent && (
      eventObject.button !== 0 || eventObject.metaKey || eventObject.ctrlKey || eventObject.shiftKey || eventObject.altKey
    )) return;
    const trigger = closestSearchTrigger(eventObject);
    if (!trigger) return;
    activateSearchTrigger(trigger, eventObject);
  }

  function bindSearchTriggers() {
    if (typeof document.querySelectorAll !== 'function') return;
    const selector = 'button[aria-controls="search-drawer"], a[aria-controls="search-drawer"], [data-open-search], a[href]';
    document.querySelectorAll(selector).forEach(trigger => {
      if (!searchTriggerContext(trigger)) return;
      if (boundSearchTriggers?.has(trigger)) return;
      boundSearchTriggers?.add(trigger);
      ['pointerdown', 'mousedown', 'click'].forEach(eventName => {
        trigger.addEventListener(eventName, eventObject => {
          if (!enabled) return;
          if (eventObject instanceof MouseEvent && (
            eventObject.button !== 0 || eventObject.metaKey || eventObject.ctrlKey || eventObject.shiftKey || eventObject.altKey
          )) return;
          activateSearchTrigger(trigger, eventObject);
        }, true);
      });
    });
  }

  function pretty(value) {
    const raw = String(value || '');
    const key = raw.toLocaleLowerCase('es');
    if (displayNames[key]) return displayNames[key];
    const text = raw.replaceAll('-', ' ');
    return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
  }

  function intentLabel(value) {
    if (labels.intent[value]) return labels.intent[value];
    const [field, ...parts] = String(value).split(':');
    const detail = parts.join(':');
    const prefix = labels.intentPrefix[field];
    if (!prefix) return pretty(value);
    if (field !== 'price') return `${prefix}: ${pretty(detail)}`;
    if (parts[0] === 'max') return locale === 'en'
      ? `${prefix}: up to ${formatMoney(parts[1], currency)}`
      : `${prefix}: hasta ${formatMoney(parts[1], currency)}`;
    if (parts[0] === 'min') return locale === 'en'
      ? `${prefix}: from ${formatMoney(parts[1], currency)}`
      : `${prefix}: desde ${formatMoney(parts[1], currency)}`;
    const [minimum, maximum] = detail.split('-');
    return `${prefix}: ${formatMoney(minimum, currency)}–${formatMoney(maximum, currency)}`;
  }

  function folded(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(locale);
  }

  function setOptions(config, items = config.items) {
    const { select, all, humanize } = config;
    const current = select.value;
    config.items = freshFacetItems(items, current);
    const term = select === vendor ? folded(vendorSearch.value) : '';
    const values = config.items.filter(item => !term || item.value === current || folded(item.value).includes(term)).sort((first, second) => {
      const countDifference = second.count - first.count;
      if (countDifference) return countDifference;
      return pretty(first.value).localeCompare(pretty(second.value), locale);
    });
    select.replaceChildren();
    const allOption = document.createElement('option');
    allOption.value = '';
    allOption.textContent = all;
    select.append(allOption);
    for (const item of values) {
      const option = document.createElement('option');
      option.value = item.value;
      option.textContent = `${humanize ? pretty(item.value) : item.value} (${item.count})`;
      option.selected = item.value === current;
      select.append(option);
    }
  }

  function clearFacetData() {
    facetConfigs.forEach(config => {
      config.items = [];
      setOptions(config, []);
    });
  }

  function updateFacets(data) {
    const facets = data?.facets || {};
    facetConfigs.forEach(config => setOptions(config, facets[config.key] || []));
  }

  function activeFilterCount() {
    return facetSelects.filter(select => select.value).length
      + [stock, sale].filter(control => control.checked).length
      + Number(rimless.checked && !currentIntents.includes('rimless'))
      + currentIntents.length;
  }

  function updateFilterCount() {
    const count = activeFilterCount();
    filterCount.textContent = String(count);
    filterCount.setAttribute('aria-label', labels.activeFilters(count));
    filterCount.hidden = count === 0;
    return count;
  }

  function hideError() {
    errorBox.hidden = true;
    results.classList.remove('is-stale');
    lastFailure = null;
  }

  function skeletons() {
    results.replaceChildren();
    for (let index = 0; index < 8; index += 1) {
      const item = document.createElement('li');
      item.className = 'ohs-skeleton';
      item.setAttribute('aria-hidden', 'true');
      results.append(item);
    }
  }

  function renderIntents(values) {
    currentIntents = [...new Set((values || []).map(String))];
    syncInferredCheckbox(rimless, currentIntents.includes('rimless'));
    intents.replaceChildren();
    for (const value of currentIntents) {
      const chip = document.createElement('button');
      const text = intentLabel(value);
      chip.type = 'button';
      chip.className = 'ohs-intent';
      chip.setAttribute('aria-label', labels.removeIntent(text));
      chip.textContent = text;
      const removeIcon = document.createElement('span');
      removeIcon.textContent = '×';
      removeIcon.setAttribute('aria-hidden', 'true');
      chip.append(removeIcon);
      chip.addEventListener('click', () => {
        const updatedQuery = removeIntentFromQuery(input.value, value);
        input.value = updatedQuery.length >= 2 ? updatedQuery : (locale === 'en' ? 'glasses' : 'gafas');
        currentIntents = currentIntents.filter(item => item !== value);
        renderIntents(currentIntents);
        updateFilterCount();
        updateNativeLinks();
        search({ useSemantic: lastSemantic, append: false, focusResults: false });
      });
      intents.append(chip);
    }
    intents.hidden = intents.childElementCount === 0;
    updateFilterCount();
  }

  function clearFilters() {
    const focusResults = results.contains(document.activeElement);
    const clearedQuery = removeIntentsFromQuery(input.value, currentIntents);
    input.value = clearedQuery.length >= 2 ? clearedQuery : (locale === 'en' ? 'glasses' : 'gafas');
    currentIntents = [];
    renderIntents([]);
    facetSelects.forEach(select => { select.value = ''; });
    vendorSearch.value = '';
    stock.checked = false;
    sale.checked = false;
    rimless.checked = false;
    updateFilterCount();
    updateNativeLinks();
    search({ useSemantic: lastSemantic, append: false, focusResults });
  }

  function renderEmpty() {
    const empty = document.createElement('li');
    empty.className = 'ohs-empty';
    const title = document.createElement('h4');
    title.textContent = labels.none;
    const copy = document.createElement('p');
    copy.textContent = labels.emptyHelp;
    const actions = document.createElement('div');
    actions.className = 'ohs-empty__actions';
    if (activeFilterCount()) {
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.textContent = labels.clearFilters;
      clear.addEventListener('click', clearFilters);
      actions.append(clear);
    }
    const classic = document.createElement('a');
    classic.href = classicSearchUrl();
    classic.dataset.ohsNative = '';
    classic.textContent = labels.classic;
    actions.append(classic);
    empty.append(title, copy, actions);
    results.replaceChildren(empty);
  }

  function shopifyImageUrl(source, width) {
    try {
      const url = new URL(source, location.origin);
      if (!/(^|\.)(cdn\.)?shopify\.com$/i.test(url.hostname)) return source;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) {
      return source;
    }
  }

  function addImageFallback(media) {
    if (media.querySelector('.ohs-image-fallback')) return;
    const fallback = document.createElement('span');
    fallback.className = 'ohs-image-fallback';
    fallback.textContent = labels.imageUnavailable;
    fallback.setAttribute('aria-hidden', 'true');
    media.append(fallback);
  }

  function renderCard(product, query, context) {
    const item = document.createElement('li');
    item.className = 'ohs-card';
    const card = document.createElement('a');
    card.className = 'ohs-card__link';
    card.href = localizedProductUrl(product.url, location.origin, localizedRootUrl);
    card.dataset.ohsProductId = String(product.product_id ?? '');
    card.dataset.ohsPosition = String(context.position);
    card.addEventListener('click', () => {
      const attribution = {
        query,
        request_id: context.request_id,
        page: context.page,
        position: context.position,
        product_id: String(product.product_id),
        result_count: context.result_count,
        filters: context.filters,
        intents: context.intents,
        mode: context.mode
      };
      rememberAttribution(attribution);
      persistCartAttribution(attribution);
      analyticsEvent('click', attribution);
    });

    const media = document.createElement('div');
    media.className = 'ohs-card__image';
    if (product.image_url) {
      const image = document.createElement('img');
      image.src = shopifyImageUrl(product.image_url, 500);
      const candidates = [240, 360, 500, 720]
        .map(width => `${shopifyImageUrl(product.image_url, width)} ${width}w`);
      if (new Set(candidates.map(candidate => candidate.split(' ')[0])).size > 1) {
        image.srcset = candidates.join(', ');
        image.sizes = '(max-width: 680px) 45vw, (max-width: 900px) 30vw, 260px';
      }
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 500;
      image.height = 500;
      image.addEventListener('error', () => {
        image.remove();
        addImageFallback(media);
      }, { once: true });
      media.append(image);
    } else {
      addImageFallback(media);
    }

    const body = document.createElement('div');
    body.className = 'ohs-card__body';
    const brand = document.createElement('p');
    brand.className = 'ohs-card__vendor';
    brand.textContent = product.vendor;
    const title = document.createElement('p');
    title.className = 'ohs-card__title';
    title.textContent = product.title;
    const meta = document.createElement('div');
    meta.className = 'ohs-card__meta';
    const priceBox = document.createElement('span');
    priceBox.className = 'ohs-card__price';
    const currentPrice = document.createElement('span');
    const productCurrency = String(product.currency || context.currency || currency).toLocaleUpperCase('en');
    const minimumPriceText = formatMoney(product.min_price || 0, productCurrency);
    const maximumPriceText = formatMoney(product.max_price || product.min_price || 0, productCurrency);
    if (Number(product.max_price) > Number(product.min_price)) {
      currentPrice.textContent = labels.fromPrice(minimumPriceText);
      currentPrice.setAttribute('aria-label', labels.priceRange(minimumPriceText, maximumPriceText));
      currentPrice.title = labels.priceRange(minimumPriceText, maximumPriceText);
    } else {
      currentPrice.textContent = minimumPriceText;
      currentPrice.setAttribute('aria-label', `${labels.currentPrice}: ${minimumPriceText}`);
    }
    priceBox.append(currentPrice);
    if (!shouldHideComparePrice(product) && product.compare_at_price > product.min_price) {
      const compare = document.createElement('span');
      const previousPriceText = formatMoney(product.compare_at_price, productCurrency);
      compare.className = 'ohs-card__compare';
      compare.textContent = previousPriceText;
      compare.setAttribute('aria-label', `${labels.previousPrice}: ${previousPriceText}`);
      priceBox.append(compare);
    }
    const availability = document.createElement('span');
    availability.className = `ohs-card__stock${product.in_stock ? '' : ' ohs-card__stock--order'}`;
    availability.textContent = product.in_stock ? labels.inStock : labels.order;
    meta.append(priceBox, availability);
    body.append(brand, title, meta);
    card.append(media, body);
    item.append(card);
    return item;
  }

  function addFilterParams(params) {
    if (vendor.value) params.set('vendor', vendor.value);
    if (type.value) params.set('product_type', type.value);
    if (gender.value) params.set('gender', gender.value);
    if (shape.value) params.set('shape', shape.value);
    if (color.value) params.set('color', color.value);
    if (material.value) params.set('material', material.value);
    if (style.value) params.set('style', style.value);
    if (size.value) params.set('size', size.value);
    if (lens.value) params.set('lens_filter', lens.value);
    if (price.value) {
      const [minimum, maximum] = price.value.split(':');
      if (minimum) params.set('min_price', minimum);
      if (maximum) params.set('max_price', maximum);
    }
    if (stock.checked) params.set('in_stock', 'true');
    if (sale.checked) params.set('on_sale', 'true');
    if (isExplicitCheckbox(rimless)) params.set('rimless', 'true');
  }

  function updatePagination() {
    filterDone.textContent = labels.viewResults(totalFound);
    if (!renderedCount || !totalFound) {
      pagination.hidden = true;
      return;
    }
    pagination.hidden = false;
    showing.textContent = labels.showing(renderedCount, totalFound);
    loadMore.hidden = !hasMore;
    loadMore.disabled = false;
    loadMore.textContent = labels.loadMore;
  }

  function resetForShortQuery(showMinimum = false) {
    cancelPending();
    lastQuery = '';
    clearFacetData();
    currentPage = 0;
    totalFound = 0;
    renderedCount = 0;
    hasMore = false;
    seenProducts.clear();
    hideError();
    status.textContent = showMinimum ? labels.minimum : labels.initial;
    controls.hidden = true;
    renderIntents([]);
    pagination.hidden = true;
    results.replaceChildren();
    updateNativeLinks();
  }

  function showError(timedOut, failure) {
    const retainedResults = Boolean(results.querySelector('.ohs-card'));
    if (results.querySelector('.ohs-skeleton')) results.replaceChildren();
    errorText.textContent = timedOut
      ? (retainedResults ? labels.timeoutErrorPrevious : labels.timeoutError)
      : (retainedResults ? labels.requestErrorPrevious : labels.requestError);
    errorBox.hidden = false;
    results.classList.toggle('is-stale', retainedResults);
    retry.textContent = labels.retry;
    retry.disabled = false;
    lastFailure = failure;
    updateNativeLinks();
    analyticsEvent('error', {
      query: failure.query,
      request_id: failure.request_id,
      page: failure.page,
      filters: failure.filters,
      reason: timedOut ? 'timeout' : 'request_failed',
      status: failure.status || null
    });
    return retainedResults;
  }

  async function search({ useSemantic = false, append = false, followRedirect = false, focusResults = false } = {}) {
    const query = input.value.trim();
    updateNativeLinks(query);
    if (query.length < 2) {
      resetForShortQuery(query.length > 0);
      return;
    }
    if (append && (!currentPage || !hasMore)) return;

    clearTimeout(timer);
    const page = append ? currentPage + 1 : 1;
    const hadLoadMoreFocus = document.activeElement === loadMore;
    const hadRetryFocus = document.activeElement === retry;
    const existingCards = Boolean(results.querySelector('.ohs-card'));
    const sequence = ++requestSequence;
    const requestId = createRequestId();
    const requestFilters = selectedFilters();
    if (controller) controller.abort();
    const localController = new AbortController();
    controller = localController;
    let timedOut = false;
    const timeout = setTimeout(() => {
      timedOut = true;
      localController.abort();
    }, 8000);

    lastQuery = query;
    if (!append) lastSemantic = useSemantic;
    hideError();
    updateFilterCount();
    results.setAttribute('aria-busy', 'true');
    filterDone.disabled = true;
    if (append) {
      status.textContent = labels.loadingMore(renderedCount, totalFound);
      loadMore.disabled = true;
      loadMore.textContent = labels.loading;
    } else {
      status.textContent = labels.searching;
      if (existingCards) results.classList.add('is-refining');
      else skeletons();
    }

    const params = new URLSearchParams({
      q: query,
      locale,
      language,
      country,
      market,
      currency,
      page: String(page),
      per_page: '24',
      semantic: useSemantic ? 'true' : 'false',
      compact: 'true'
    });
    if (page > 1) params.set('facets', 'false');
    addFilterParams(params);

    let responseStatus = null;
    try {
      const response = await fetch(`${endpoint}/v1/search?${params}`, {
        mode: 'cors',
        signal: localController.signal
      });
      responseStatus = response.status;
      if (!response.ok) throw new Error(`search-${response.status}`);
      const data = await response.json();
      if (sequence !== requestSequence) return;
      healthState = 'ready';
      enabled = true;
      writeHealthCache(true);
      if (data.redirect_url && followRedirect) {
        location.assign(data.redirect_url);
        return;
      }

      const hits = Array.isArray(data.hits) ? data.hits : [];
      const resolvedRequestId = String(data.request_id || response.headers.get('x-request-id') || requestId);
      const resolvedMode = String(data.mode || (useSemantic ? 'semantic' : 'lexical'));
      const responseCurrency = String(data.currency || indexCurrency).toLocaleUpperCase('en');
      currentResponseCurrency = responseCurrency;
      const priceFilterSupported = typeof data.price_filter_supported === 'boolean'
        ? data.price_filter_supported
        : responseCurrency === indexCurrency;
      price.disabled = !priceFilterSupported;
      price.title = priceFilterSupported ? '' : labels.priceFilterUnavailable;
      if (!append) {
        results.replaceChildren();
        results.scrollTop = 0;
        seenProducts.clear();
        updateFacets(data);
        renderIntents(data.intents);
      }

      let firstAddedLink = null;
      for (const product of hits) {
        const identifier = String(product.product_id ?? product.id ?? product.url);
        if (seenProducts.has(identifier)) continue;
        const position = seenProducts.size + 1;
        seenProducts.add(identifier);
        const card = renderCard(product, query, {
          request_id: resolvedRequestId,
          page,
          position,
          result_count: Number(data.found) || 0,
          filters: requestFilters,
          intents: [...currentIntents],
          mode: resolvedMode,
          currency: responseCurrency
        });
        results.append(card);
        if (!firstAddedLink) firstAddedLink = card.querySelector('a');
      }

      currentPage = page;
      totalFound = Number(data.found) || 0;
      renderedCount = seenProducts.size;
      hasMore = typeof data.has_more === 'boolean'
        ? data.has_more
        : page < (Number(data.total_pages) || Math.ceil(totalFound / 24));
      currentRequestId = resolvedRequestId;
      currentResultMode = resolvedMode;
      controls.hidden = false;
      updateFilterCount();
      if (!renderedCount) {
        status.textContent = labels.none;
        renderEmpty();
      } else {
        status.textContent = labels.showing(renderedCount, totalFound);
      }
      updatePagination();
      analyticsEvent(append ? 'load_more' : 'search', {
        query,
        request_id: resolvedRequestId,
        page,
        result_count: totalFound,
        filters: requestFilters,
        intents: [...currentIntents],
        mode: resolvedMode,
        ms: Number(data.search_time_ms) || 0
      });
      if ((hadLoadMoreFocus || hadRetryFocus || focusResults) && firstAddedLink) firstAddedLink.focus();
      else if ((hadRetryFocus || focusResults) && !firstAddedLink) status.focus();
    } catch (error) {
      if (sequence !== requestSequence) return;
      if (error.name === 'AbortError' && !timedOut) return;
      const retainedResults = showError(timedOut, {
        useSemantic,
        append,
        followRedirect,
        focusResults,
        query,
        request_id: requestId,
        page,
        filters: requestFilters,
        status: responseStatus
      });
      status.textContent = retainedResults ? labels.showing(renderedCount, totalFound) : '';
      if (hadRetryFocus) requestAnimationFrame(() => retry.focus());
    } finally {
      clearTimeout(timeout);
      if (sequence === requestSequence) {
        controller = null;
        results.setAttribute('aria-busy', 'false');
        results.classList.remove('is-refining');
        loadMore.disabled = false;
        loadMore.textContent = labels.loadMore;
        filterDone.disabled = false;
      }
    }
  }

  form.addEventListener('submit', eventObject => {
    eventObject.preventDefault();
    search({ useSemantic: true, append: false, followRedirect: true });
  });
  input.addEventListener('input', () => {
    clearTimeout(timer);
    hideError();
    renderIntents([]);
    updateNativeLinks();
    if (input.value.trim().length < 2) resetForShortQuery(input.value.trim().length > 0);
    else timer = setTimeout(() => search({ useSemantic: false, append: false }), 300);
  });
  [...facetConfigs.map(config => config.select), price, stock, sale, rimless].forEach(control => {
    control.addEventListener('change', () => {
      if (control === vendor) vendorSearch.value = '';
      if (control === rimless) {
        const removesInferredIntent = !rimless.checked
          && (isInferredCheckbox(rimless) || currentIntents.includes('rimless'));
        if (removesInferredIntent) {
          const updatedQuery = removeIntentFromQuery(input.value, 'rimless');
          input.value = updatedQuery.length >= 2 ? updatedQuery : (locale === 'en' ? 'glasses' : 'gafas');
          currentIntents = currentIntents.filter(item => item !== 'rimless');
          renderIntents(currentIntents);
          updateNativeLinks();
        }
        // A direct checkbox gesture is explicit from this point onward.
        delete rimless.dataset.ohsInferred;
      }
      search({ useSemantic: lastSemantic, append: false });
    });
  });
  vendorSearch.addEventListener('input', () => setOptions(facetConfigs[0]));
  reset.addEventListener('click', clearFilters);
  filterDone.addEventListener('click', () => {
    controls.open = false;
    const firstResult = results.querySelector('.ohs-card a');
    (firstResult || status).focus();
  });
  loadMore.addEventListener('click', () => search({ useSemantic: lastSemantic, append: true }));
  retry.addEventListener('click', () => {
    if (!lastFailure) return;
    retry.disabled = true;
    search(lastFailure);
  });
  close.addEventListener('click', closeSearch);
  dialog.addEventListener('keydown', eventObject => {
    if (eventObject.key !== 'Escape') return;
    eventObject.preventDefault();
    closeSearch();
  });
  dialog.addEventListener('click', eventObject => { if (eventObject.target === dialog) closeSearch(); });
  dialog.addEventListener('cancel', eventObject => {
    eventObject.preventDefault();
    closeSearch();
  });
  dialog.addEventListener('close', () => {
    cancelPending();
    if (lastTrigger instanceof HTMLElement && document.contains(lastTrigger)) {
      suppressSearchTriggerFocus = true;
      lastTrigger.focus({ preventScroll: true });
      setTimeout(() => { suppressSearchTriggerFocus = false; }, 0);
    }
    lastTrigger = null;
  });
  root.addEventListener('click', eventObject => {
    if (eventObject.target instanceof Element && eventObject.target.closest('[data-ohs-native]')) {
      analyticsEvent('fallback', {
        query: input.value.trim(),
        reason: lastFailure ? 'error_fallback' : 'user_choice',
        filters: selectedFilters()
      });
      closeSearch();
    }
  });
  ['pointerdown', 'mousedown', 'click'].forEach(eventName => {
    globalThis.addEventListener(eventName, intercept, true);
  });
  bindSearchTriggers();
  document.addEventListener('submit', eventObject => {
    const submittedForm = eventObject.target;
    if (!(submittedForm instanceof HTMLFormElement)) return;
    let action;
    try { action = new URL(submittedForm.action, location.origin); } catch (_) { return; }
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/i.test(action.pathname)) return;
    const attribution = recentAttribution();
    if (!attribution) return;
    const variantId = new FormData(submittedForm).get('id');
    analyticsEvent('add_to_cart', {
      ...attribution,
      product_id: attribution.product_id || (variantId == null ? null : String(variantId))
    });
  }, true);
  document.addEventListener('keydown', eventObject => {
    if ((eventObject.metaKey || eventObject.ctrlKey) && eventObject.key.toLowerCase() === 'k' && enabled) {
      eventObject.preventDefault();
      openSearch(document.activeElement);
    }
  });

  const healthTtl = Math.min(900_000, Math.max(60_000, Number(root.dataset.healthTtl) || 300_000));
  const healthCacheKey = `ohs_health:${endpoint}`;

  function readHealthCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(healthCacheKey) || 'null');
      if (!cached || Date.now() - Number(cached.checked_at) > healthTtl) return null;
      return Boolean(cached.ready);
    } catch (_) {
      return null;
    }
  }

  function writeHealthCache(ready) {
    try {
      localStorage.setItem(healthCacheKey, JSON.stringify({ ready: Boolean(ready), checked_at: Date.now() }));
    } catch (_) {}
  }

  function redirectToHealthyControl() {
    if (healthFallbackStarted || canaryConfig.state !== 'percentage') return false;
    const destination = healthFallbackUrl(location.href, canaryConfig.mainThemeId);
    if (!destination) return false;
    healthFallbackStarted = true;
    location.replace(destination);
    return true;
  }

  function verifyHealth({ force = false } = {}) {
    if (!endpoint) return Promise.resolve(false);
    if (healthPromise) return healthPromise;
    if (!force) {
      const cached = readHealthCache();
      if (cached !== null) {
        healthState = cached ? 'ready' : 'failed';
        enabled = cached;
        root.hidden = !cached;
        if (cached) flushRouterOpenRequest();
        return Promise.resolve(cached);
      }
    }

    const healthController = new AbortController();
    const healthTimer = setTimeout(() => healthController.abort(), 3500);
    healthState = 'checking';
    healthPromise = fetch(`${endpoint}/health`, { mode: 'cors', signal: healthController.signal })
      .then(response => { if (!response.ok) throw new Error('health'); return response.json(); })
      .then(data => {
        if (!data.ok || !data.ready || Number(data.documents) < 1) throw new Error('search-not-ready');
        healthState = 'ready';
        enabled = true;
        root.hidden = false;
        writeHealthCache(true);
        updateNativeLinks();
        bindSearchTriggers();
        flushRouterOpenRequest();
        return true;
      })
      .catch(() => {
        if (healthState === 'ready') return true;
        healthState = 'failed';
        enabled = false;
        writeHealthCache(false);
        if (redirectToHealthyControl()) return false;
        if (!dialog.open) root.hidden = true;
        else {
          errorText.textContent = labels.requestError;
          errorBox.hidden = false;
          analyticsEvent('fallback', { reason: 'health_failed', query: input.value.trim() });
        }
        return false;
      })
      .finally(() => {
        clearTimeout(healthTimer);
        healthPromise = null;
      });
    return healthPromise;
  }

  if (!endpoint) {
    enabled = false;
    root.hidden = true;
  } else {
    price.disabled = currency !== indexCurrency;
    price.title = price.disabled ? labels.priceFilterUnavailable : '';
    const cachedHealth = readHealthCache();
    if (cachedHealth === true) {
      healthState = 'ready';
      enabled = true;
      root.hidden = false;
      flushRouterOpenRequest();
    } else if (cachedHealth === false) {
      healthState = 'failed';
      enabled = false;
      root.hidden = true;
      if (canaryConfig.state === 'staff') verifyHealth({ force: true });
      else redirectToHealthyControl();
    } else {
      enabled = false;
      root.hidden = true;
      verifyHealth({ force: true });
    }
    updateNativeLinks();
    bindSearchTriggers();
  }
    return true;
  }

  function retryOwnedRuntime() {
    if (!startOwnedRuntime()) return;
    if (typeof document.removeEventListener === 'function') {
      document.removeEventListener('oh-search-canary-ready', retryOwnedRuntime);
      document.removeEventListener('DOMContentLoaded', retryOwnedRuntime);
    }
  }

  if (!startOwnedRuntime()) {
    const router = globalThis.document?.getElementById('oh-search-canary-router');
    if (router?.dataset?.runtimeStatus === 'pending') {
      document.addEventListener('oh-search-canary-ready', retryOwnedRuntime);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', retryOwnedRuntime, { once: true });
      }
    }
  }
})();
